<template>
    <div>
        <h2 v-if="!getVerifiedName()">{{ $t("wp.wpServices") }}</h2>
        <h2 v-else>{{ $t("wp.wpServices") }} - {{ getVerifiedName() }} <{{ getPhoneNumber() }}></h2>
        <span> {{ $t("wp.wpServicesIntegrationCompleted") }} </span>
        <div class="mt-5">
            <img
                v-if="!!imageData"
                :src="imageData"
                :alt="$t('wp.qrCodeImageAlt')"
                class="qr-code"
                :key="imageRefreshKey"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { getWhatsappSS } from "../../api/whatsapp";
import _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";

export default {
    name: "WPStatusViewer",
    props: {
        channelId: {
            type: String,
            required: false,
        },
        channel: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            imageRefreshKey: 0,
            imageData: null,
            isV2Channel: this.channel?.type === "whatsapp-v2",
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            me: (state) => state.whatsapp.me,
            channelPhoneDetails: (state) => state.whatsapp.channelPhoneDetails,
            siteId: (state) => state.site.site._id,
        }),
    },
    methods: {
        fetchSS() {
            getWhatsappSS(this.channelId)
                .then((res) => {
                    if (_.get(res, "data.response")) {
                        const image = _.get(res, "data.response");
                        this.imageData = image;
                        this.imageRefreshKey++;
                    } else {
                        this.imageData = null;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        getMe() {
            sendSocketMessage("whatsapp send-request", {
                siteId: this.siteId,
                path: "getMe",
                payload: {},
                channelId: this.channelId,
            });
        },
        getVerifiedName() {
            const me = this.channelId ? this.channelPhoneDetails[this.channelId] : this.me;
            return _.get(me, "verifiedName") || _.get(me, "pushname");
        },
        getPhoneNumber() {
            const me = this.channelId ? this.channelPhoneDetails[this.channelId] : this.me;
            return _.get(me, "me.user");
        },
    },
    mounted() {
        if (!this.isV2Channel) {
            this.fetchSS();
            this.timerId = setInterval(this.fetchSS, 10000);
            this.getMe();
        }
    },
    beforeDestroy() {
        if (this.timerId) clearInterval(this.timerId);
    },
};
</script>

<style scoped></style>
